// Note: the values in this enum are shown to the user
export enum MethodEditorTab {
  DEFINITIONS = 'Definitions',
  STEP_CONFIG = 'Steps',
  ANALYSIS_TEMPLATE_CONFIG = 'Data & analysis',
  TESTS = 'Tests',
  METADATA = 'Metadata',
}

// This is the default tab that we'll open to when the user opens the method editor for the first time.
export const DEFAULT_METHOD_EDITOR_TAB = MethodEditorTab.DEFINITIONS;
